import React from "react";
// Images
import logoImage from "../../assets/Images/logo.png";

const Footer = () => {
	return (
		<div className="footer">
			<div className="footer__inner">
				<div className="shell">
					<div className="footer__content">
						<h2>For more information and support</h2>
						For more research by IronmongeryDirect, visit:{" "}
						<a href="https://www.ironmongerydirect.co.uk/blog">
							https://www.ironmongerydirect.co.uk/blog
						</a>
					</div>

					<a href="#" className="logo footer__logo">
						<img src={logoImage} alt="" />
					</a>
				</div>
			</div>

			<div className="footer__entry">
				<div className="shell">
					<p>
						[1] Freedom of Information requests issued to councils
						in September and October 2021. We received 169
						responses.
					</p>
				</div>
			</div>
		</div>
	);
};

export default Footer;
